function TableSearchBarWrapper({ children }) {
  return (
    <div className="flex flex-row flex-wrap items-start lg:flex-row px-1 w-full">
      {children}
    </div>
  );
}

export default TableSearchBarWrapper;
